import * as imageConversion from 'image-conversion';
import { Injectable } from '@angular/core';

enum ImageType {
  'image/png' = 'PNG',
  'image/jpeg' = 'JPEG',
  'image/gif' = 'GIF'
}

@Injectable()
export class ImageConversionService {
  static async compressBase64StringImage(
    base64string: string,
    compress: { quality: number; height?: number; width?: number }
  ): Promise<string> {
    const base64ImageType = base64string.split(';')[0].split(':')[1];
    const conversionImageType = ImageType[base64ImageType] || ImageType['image/png'];

    let imageFile = await imageConversion.urltoBlob(base64string);

    imageFile = await imageConversion.compress(imageFile, {
      ...compress,
      type: imageConversion.EImageType[conversionImageType]
    });

    return await imageConversion.filetoDataURL(imageFile);
  }

  static async compressFileImage(
    imageFile: File,
    compress: { quality: number; height?: number; width?: number }
  ): Promise<File> {
    const conversionImageType = ImageType[imageFile.type] || ImageType['image/png'];

    let compressedImageData = (await imageConversion.compress(imageFile, {
      ...compress,
      type: imageConversion.EImageType[conversionImageType]
    })) as File;

    if (!(compressedImageData instanceof File)) {
      compressedImageData = new File([compressedImageData], imageFile.name, {
        type: imageConversion.EImageType[conversionImageType],
        lastModified: imageFile.lastModified
      });
    }

    return compressedImageData;
  }

  static isImageValid(file: File, limits: { size?: number } = {}): boolean {
    const { size } = limits;

    if (!(file.type in ImageType)) {
      return false;
    }

    if (size && file.size > size * 1024 * 1024) {
      return false;
    }

    return true;
  }
}
